// src/pages/VehicleMaintenanceTracking/VehiclesPage.jsx
import { useState } from 'react';
import { Group, Paper, Button, Text, Stack } from '@mantine/core';
import { IconDownload, IconCar } from '@tabler/icons-react';
import { notifications } from '@mantine/notifications';
import VehicleList from '../../components/VehicleMaintenanceTracking/VehicleList';
import { downloadVehicleExcel } from './utils/vehicleExcelDownload';

export default function VehiclesPage() {
  const [exporting, setExporting] = useState(false);

  const handleDownload = async () => {
    setExporting(true);
    try {
      await downloadVehicleExcel('active');
      notifications.show({ title: 'Excel indiriliyor', message: 'Aktif araç listesi - Tasarım V2', color: 'teal' });
    } catch (error) {
      notifications.show({ title: 'Excel indirilemedi', message: error.message, color: 'red' });
    } finally {
      setExporting(false);
    }
  };

  return (
    <Stack gap="md">
      <Paper p="md" radius="xl" withBorder>
        <Group justify="space-between" gap="sm" wrap="wrap">
          <Group gap="xs">
            <IconCar size={22} />
            <div>
              <Text fw={700}>Aktif Araç Listesi - Excel</Text>
              <Text size="xs" c="dimmed">Yönetici Özeti, KPI kartları ve detaylı filo tablosu (Tasarım V2)</Text>
            </div>
          </Group>
          <Button
            color="teal"
            radius="xl"
            leftSection={<IconDownload size={18} />}
            loading={exporting}
            onClick={handleDownload}
          >
            Excel İndir (V2)
          </Button>
        </Group>
      </Paper>
      <VehicleList />
    </Stack>
  );
}
